export const QF = 0;
export const QSIM = 1;
export const QSEQ = 2;
export const DQD = 3;
